import Vue from 'vue'
import * as types from './types'
import { createInitialState, createInboxState, createMessagesState } from './state'
import { mergeMessages } from '../utils/messages'
import { mergeInboxIds, moveToTop } from '../utils/inbox'

const ensureMessages = (state, conversationId) => {
  if (!state.messages[conversationId]) Vue.set(state.messages, conversationId, createMessagesState())
  return state.messages[conversationId]
}

export default {
  [types.MUTATE_STATUS]: (state, status) => {
    state.status = status
  },
  [types.MUTATE_CONNECTION_STATUS]: (state, status) => {
    state.connectionStatus = status
  },
  [types.MUTATE_ACTIVE_SCOPE]: (state, scope) => {
    state.activeScope = scope
  },
  [types.MUTATE_INBOX_LOADING]: (state, { scope, loading, error = false }) => {
    if (!state.inbox[scope]) Vue.set(state.inbox, scope, createInboxState())
    state.inbox[scope].loading = loading
    state.inbox[scope].error = error
  },
  [types.MUTATE_INBOX_PAGE]: (state, {
    scope, ids, page, hasMore, append,
  }) => {
    if (!state.inbox[scope]) Vue.set(state.inbox, scope, createInboxState())
    const inbox = state.inbox[scope]
    inbox.ids = mergeInboxIds(inbox.ids, ids, append)
    inbox.page = page
    inbox.hasMore = hasMore
    inbox.loaded = true
    inbox.loading = false
    inbox.error = false
  },
  [types.MUTATE_UPSERT_CONVERSATIONS]: (state, conversations) => {
    (conversations || []).forEach(conversation => {
      if (!conversation || !conversation.conversationId) return
      const existing = state.conversations[conversation.conversationId] || {}
      Vue.set(state.conversations, conversation.conversationId, { ...existing, ...conversation })
    })
  },
  [types.MUTATE_MOVE_CONVERSATION_TO_TOP]: (state, conversationId) => {
    Object.keys(state.inbox).forEach(scope => {
      const inbox = state.inbox[scope]
      if (inbox.ids.includes(conversationId)) inbox.ids = moveToTop(inbox.ids, conversationId)
    })
  },
  [types.MUTATE_OPEN_CONVERSATION_ID]: (state, conversationId) => {
    state.openConversationId = conversationId || null
  },
  [types.MUTATE_VIEW_VISIBLE]: (state, visible) => {
    state.viewVisible = !!visible
  },
  [types.MUTATE_MERGE_MESSAGES]: (state, { conversationId, messages }) => {
    const entry = ensureMessages(state, conversationId)
    entry.items = mergeMessages(entry.items, messages)
  },
  [types.MUTATE_MESSAGES_STATE]: (state, { conversationId, ...patch }) => {
    const entry = ensureMessages(state, conversationId)
    Object.keys(patch).forEach(key => {
      entry[key] = patch[key]
    })
  },
  [types.MUTATE_MESSAGE_LOCAL_STATUS]: (state, {
    conversationId, clientMessageId, localStatus, errorMessage,
  }) => {
    const entry = ensureMessages(state, conversationId)
    entry.items = entry.items.map(message => (message.clientMessageId === clientMessageId && !message.id
      ? { ...message, localStatus, errorMessage }
      : message))
  },
  [types.MUTATE_REMOVE_PENDING_MESSAGE]: (state, { conversationId, clientMessageId }) => {
    const entry = ensureMessages(state, conversationId)
    entry.items = entry.items.filter(message => message.id || message.clientMessageId !== clientMessageId)
  },
  [types.MUTATE_CUSTOMER_READ]: (state, { conversationId, lastReadSeq }) => {
    const current = state.customerReadSeq[conversationId] || 0
    Vue.set(state.customerReadSeq, conversationId, Math.max(current, Number(lastReadSeq) || 0))
  },
  [types.MUTATE_MY_READ]: (state, { conversationId, lastReadSeq }) => {
    const current = state.myReadSeq[conversationId] || 0
    Vue.set(state.myReadSeq, conversationId, Math.max(current, Number(lastReadSeq) || 0))
    const conversation = state.conversations[conversationId]
    if (conversation) Vue.set(state.conversations, conversationId, { ...conversation, unreadCount: 0 })
  },
  [types.MUTATE_TYPING]: (state, { conversationId, displayName, until }) => {
    if (displayName) Vue.set(state.typing, conversationId, { displayName, until })
    else Vue.delete(state.typing, conversationId)
  },
  // Quem saiu (ou foi removido) de uma conversa não a vê mais em nenhum inbox.
  [types.MUTATE_REMOVE_FROM_INBOXES]: (state, conversationId) => {
    Object.keys(state.inbox).forEach(scope => {
      const inbox = state.inbox[scope]
      inbox.ids = inbox.ids.filter(id => id !== conversationId)
    })
    Vue.delete(state.conversations, conversationId)
    Vue.delete(state.messages, conversationId)
  },
  [types.MUTATE_RESET]: state => {
    Object.assign(state, createInitialState())
  },
}
